import { AppPaths } from "@p0security/shared/routes/constants";
import { Evidence } from "@p0security/shared/types/evidence";
import { assertNever } from "@p0security/shared/types/index";
import { Typography } from "antd";
import { GraphTooltip } from "components/GraphTooltip";

import { TenantAwareLink } from "../../common/TenantAwareLink";
import { JitPaths } from "../paths";

export const renderPreApproval = (
  preApproval: readonly [Evidence["source"], string] | "unknown" | undefined,
  richOutput: boolean // Whether to include links and tooltips, or just plain text
) => {
  if (!preApproval) {
    return "";
  }

  if (preApproval === "unknown") {
    return "Unknown pre approval ID";
  }

  const [source, id] = preApproval;

  switch (source) {
    case "request":
      return richOutput ? (
        <>
          Pre-approval from{" "}
          <TenantAwareLink
            to={`${AppPaths.AccessManagement}/${JitPaths.Activity}/${id}`}
          >
            request
          </TenantAwareLink>
        </>
      ) : (
        `Pre-approval from request ${id}`
      );
    case "allow":
      return richOutput ? (
        <>
          <GraphTooltip
            title={
              <>
                Pre-approval from <code>p0 allow</code> is not yet supported in
                the web view, and can be managed using the P0 CLI.
              </>
            }
          >
            <Typography.Text
              ellipsis
              type="secondary"
              className="sub-text"
              style={{
                textDecoration: "underline dashed",
              }}
            >
              Pre-approval ID: {id}
            </Typography.Text>
          </GraphTooltip>
        </>
      ) : (
        `Pre-approval from p0 allow ${id}`
      );
    default:
      assertNever(source);
  }
};
